import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Fried Chicken Sandwich',
  source: 'https://littlesunnykitchen.com/chick-fil-a-chicken-sandwich-copycat/',
  totalTime: time(0, 30),
  servings: 4,
  tags: { type: 'main' },
  ingredients: [
    { name: 'chicken breasts', quantity: '2',
      note: ['sliced into ', { multiply: 2 }, ' thin cutlets'],
    },
    { name: 'milk', quantity: '1', unit: 'cup' },
    { name: 'eggs', quantity: '2' },
    { name: 'smoked paprika', quantity: '2', unit: 'tsp' },
    { name: 'cayenne powder', quantity: '1/2', unit: 'tsp' },
    { name: 'garlic powder', quantity: '2', unit: 'tsp' },
    { name: 'black pepper', quantity: '2', unit: 'tsp' },
    { name: 'salt', quantity: '2', unit: 'tsp' },
    { name: 'all-purpose flour', quantity: '1', unit: 'cup' },
    { name: 'milk powder', quantity: '2', unit: 'tbsp' },
    { name: 'granulated sugar', quantity: '1', unit: 'tsp' },
    { name: 'baking powder', quantity: '1', unit: 'tsp' },
    { name: 'frying oil', quantity: '2', unit: 'quart',
      fixed: true,
    },
    { name: 'buns', quantity: '4' },
    { name: 'butter', quantity: '2', unit: 'tsp' },
    { name: 'bread & butter pickle chips', quantity: '12' },
    { name: 'chick-fil-a sauce', quantity: '1', unit: 'recipe', customUnit: true,
      recipe: 'chick-fil-a-sauce',
    },
  ],
  directions: [
    {
      title: 'Whisk wet',
      bullets: [
        "In shallow dish, whisk {eggs} & {milk}",
      ],
    },
    {
      title: 'Mix spice blend',
      bullets: [
        "In small bowl, combine {smoked paprika}, {cayenne powder}, {garlic powder}, {black pepper} & {salt}",
      ],
    },
    {
      title: 'Build dredge',
      bullets: [
        "In wide dish, combine {all-purpose flour}, {milk powder}, {granulated sugar}, {baking powder} & spice blend",
        "Add {=2 tbsp} egg-milk mixture to dredge",
        "Rub with fingertips until flour is coarse & shaggy",
      ],
    },
    {
      title: 'Bread & fry',
      bullets: [
        "In deep fryer, heat {frying oil} to {!350F}",
        "Dip each {chicken breasts} cutlet in wet mixture, letting excess drip off",
        "Dredge in dry mixture & press firmly to adhere",
        "Gently shake off excess & lower into hot oil",
        "Fry 4 min until internal temperature reaches {!165F}",
        "Transfer to paper towel-lined plate",
      ],
    },
    {
      title: 'Toast buns',
      bullets: [
        "Spread {butter} on cut sides of {buns}",
        "In skillet, toast buttered sides over medium heat until golden",
      ],
    },
    {
      title: 'Assemble',
      bullets: [
        "Spread {chick-fil-a sauce} on both sides of toasted buns",
        "Top each bun with {bread & butter pickle chips} & fried chicken",
      ],
    },
  ],
};

export default recipe;
